import AuthGuard from './auth/AuthGuard';
import chartsRoute from './views/charts/ChartsRoute';
import dashboardRoutes from './views/dashboard/DashboardRoutes';
import materialRoutes from './views/material-kit/MaterialRoutes';
import settingsRoute from './views/settings/settingsRoutes';
import NotFound from './views/sessions/NotFound';
import sessionRoutes from './views/sessions/SessionRoutes';
import { Navigate } from 'react-router-dom';
import MatxLayout from './components/MatxLayout/MatxLayout';
import categoryRoute from './views/master/MasterRoute';
// import inventoryRoute from './views/inventory/inventoryroute'; 
import reportRoutes from './views/reports/reportRoutes';
import leaveRoute from './views/leavemanagment/leaveManagmentRoute';
import attendanceRoute from './views/attendance/attendanceRoute';
import reportRoute from './views/hrReport/hrReport';
import projectRoute from './views/projectmanagment/projectManagmentRoute';
import taskManagementRoute from './views/taskmanagement/taskManagementRoute';
import chatRoute from './views/chat/chatRoute';
import crmRoutes from './views/crm/crmRoutes';
const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...dashboardRoutes,
      ...chartsRoute,
      ...materialRoutes,
      ...settingsRoute,
      ...categoryRoute,
      // ...inventoryRoute,
      ...reportRoutes,
      ...leaveRoute,
      ...attendanceRoute,
      ...reportRoute,
      ...projectRoute,
      ...taskManagementRoute,
      ...chatRoute,
      ...crmRoutes,

    ],
  },
  ...sessionRoutes,
  { path: '/', element: <Navigate to="dashboard/default" /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
